module.exports = __webpack_public_path__ + "static/img/nc124.261c31f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nc124.png
// module id = p9mo
// module chunks = 73